var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 mb-3",class:{'chart-loading': _vm.loading}},[_vm._m(0),_c('Chart',{key:_vm.componentKey,attrs:{"type":"bar","data":_vm.basicData,"options":_vm.basicOptions}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"mb-3"},[_c('b',[_vm._v("Tổng Số Lượng Rủi Ro Theo Khu Vực Làm Việc")])])
}]

export { render, staticRenderFns }